export const chronicIssuesMap = {
  DIABETES_REVERSAL: "DIABETES",
  PRE_DIABETES_REVERSAL: "PRE_DIABETES",
};

export const issueTypeGuidelinesMap = {
  "Type 1": [
    "If your blood glucose level is less than 100 mg/dl before you start your activity, try having a small carbohydrate snack (about 15 grams) to increase your blood glucose and reduce your risk for hypoglycemia. This is especially important if you took insulin recently and if you will be exercising for longer than 30 minutes.",
    "If your blood glucose is high(>250mg/dl) before starting exercise, check your blood or urine for ketones. If you test positive for ketones, avoid vigorous activity.",
    "If you do not have ketones in your blood or urine and you feel well, it should be fine to exercise.",
    "Maintain proper foot care as advised by the doctor.",
    "Be alert to hypoglycemic symptoms. In case of symptoms of palpitation, sweating, weakness and hunger, check your blood sugar levels and take a snack if blood glucose is low.",
  ],
  "Type 2": [
    "Maintain proper foot care as advised by the doctor.",
    "Be alert to hypoglycemic symptoms. In case of symptoms of palpitation, sweating, weakness and hunger, check your blood sugar levels and take a snack if blood glucose is low.",
  ],
  "Pre-diabetic": [],
};
